import { AppRoute } from '@app/core/routing/AppRoute';
import { Redirect, Switch } from 'react-router-dom';
import { ContentPage } from '../screens/content/ContentPage';
import { ContentsListPage } from '../screens/contents-list/ContentsListPage';

export function ContentAiRoutes() {
  return (
    <Switch>
      <AppRoute exact path={`/content-ai/contents`} component={ContentsListPage} />

      <AppRoute exact path={`/content-ai/contents/:contentId`} component={ContentPage} />

      {/* catch all */}
      <Redirect exact to={`/content-ai/contents`} />
    </Switch>
  );
}
